module.exports = __webpack_public_path__ + "static/pillar-close-da5086a607c216c37755fb2ac2e00028.jpg";